import { firestore } from "firebase";
import {
  IresDevice,
  IresDeviceGeneration,
  getIresDeviceGeneration,
  IresDeviceStatus,
} from "./IresDevice";

export interface Panel extends IresDevice {
  inventoryNumber: string;
  panelStatus?: PanelStatus;
  configurationName: string;
  panelType: number;

  buildVersion: number;
  firmwareRevision: string;
}

export interface PanelStatus extends IresDeviceStatus {
  online: boolean;
  cellId: string | null;
  currentChipTemp?: number;
  currentWallTemp: number;
  activeRunId: number;
  currentWallTemp2?: number;
  ipuStatus: number;
  totalPowerUsed: number;

  activeProgram: number;
  currentStep: number;
  currentCycle: number;

  timeSpanFirstStepHeatNorm: number;
  rateFirstStepHeatNorm: number;
  rateStepHeat: number;
  rateStepCool: number;
  rateStepHeatCool: number;
}

export interface StatusHistory {
  createdAt: firestore.Timestamp;
  ipuStatus: number;
}

export enum PanelType {
  EDGE = "EA",
  SLIM = "SA",
  HYDRY = "HA",
}

export function getPanelTypeFromSerialNumber(serialNumber: string): PanelType {
  if (serialNumber.startsWith("E")) {
    return PanelType.EDGE
  } else if (serialNumber.startsWith("S")) {
    return PanelType.SLIM
  }

  return PanelType.HYDRY
}

export function getPanelType(panel: Panel): PanelType {
  switch (panel.panelType) {
    case 1:
      return PanelType.SLIM;
    case 2:
      return PanelType.EDGE;
    default:
      return PanelType.HYDRY;
  }
}

export function supportsIot(iresDevice: IresDevice) {
  if (!iresDevice) {
    return false;
  }

  return getIresDeviceGeneration(iresDevice) >= IresDeviceGeneration.D;
}

export function hasPanelElictricityMeter(panel: Panel) {
  if (!panel) {
    return false;
  }

  return getIresDeviceGeneration(panel) !== IresDeviceGeneration.A;
}

export function isEdgePanel(panel: Panel) {
  return getPanelType(panel) === PanelType.EDGE;
}

export default Panel;
